import React, { useState } from 'react';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleLogin() {
    if (!username.trim() || !password.trim()) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Login failed'); return; }
      localStorage.setItem('dj_token', data.token);
      localStorage.setItem('dj_user', JSON.stringify(data.user));
      onLogin(data.user);
    } catch {
      setError('Connection error');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-screen">
      <div className="login-logo">RISHAB</div>
      <div className="login-sub">Rishab World Private Limited</div>

      <input
        className="login-input"
        type="text"
        placeholder="Phone number / username"
        value={username}
        onChange={e => setUsername(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && handleLogin()}
        autoComplete="username"
        autoFocus
      />
      <input
        className="login-input"
        type="password"
        placeholder="Password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && handleLogin()}
        autoComplete="current-password"
        style={{ marginTop: 12 }}
      />
      <div className="login-hint">Use your ERP phone number &amp; password</div>

      {error && <div style={{ color: 'var(--red)', fontSize: 13, marginBottom: 16, textAlign: 'center' }}>{error}</div>}

      <button className="btn-primary" onClick={handleLogin} disabled={loading || !username || !password}>
        {loading ? 'Signing in...' : 'ENTER'}
      </button>
    </div>
  );
}
